import { accountApi } from '../../../redux/api/AccountApi';
import { ValidateOtp } from '../types';

export const forgotPasswordApi = accountApi.injectEndpoints({
    endpoints: (builder) => ({
        generateOtp: builder.query<any, { email: string, action?: string }>({
            query: (params) => ({
                url: `generateOtp/${params.email}`,
                params: {
                    action: params.action
                }
            }),
            transformResponse: (response: { body: any }, meta, arg) => {
                return response.body;
            }
        }),
        validateOtp: builder.mutation<any, ValidateOtp>({
            query: (body) => {
                return ({
                    url: `validateOtp`,
                    method: 'POST',
                    body: {
                        email: body.email,
                        otp: body.otp,
                    }
                })
            },
            transformResponse: (response: { body: any }, meta, arg) => {
                return response.body;
            }
        }),
        validateOtpChangePass: builder.mutation<any, ValidateOtp>({
            query: (body) => {
                return ({
                    url: `validateOtpChangePass`,
                    method: 'POST',
                    body: {
                        email: body.email,
                        otp: body.otp,
                    }
                })
            },
            transformResponse: (response: { body: any }, meta, arg) => {
                return response.body;
            }
        }),
        validateOtpAndChangePass: builder.mutation<any, ValidateOtp>({
            query: (body) => ({
                url: `validateOtpAndChangePass`,
                method: 'POST',
                body
            }),
            transformResponse: (response: { body: any }, meta, arg) => {
                return response.body;
            }
        })
    })
})

export const {
    useLazyGenerateOtpQuery,
    useValidateOtpAndChangePassMutation,
    useValidateOtpMutation,
    useValidateOtpChangePassMutation } = forgotPasswordApi;
